import React from 'react';
import projectRequirementsArray from '../../utils/projectRequirementsArray';

const KnockoutDraftHeader = ({referralMessageInDraft}) => {
    return (
        <header>
            <div className="h2 mt mb">
                <strong>After review, you must hit "Submit" at the bottom of the page in order to receive terms</strong>
            </div>
            <div className="submission-reasons">
            <p>
                We couldn&apos;t provide an instant
                pricing summary for the following reason(s):
            </p>
            <ul>
                {referralMessageInDraft.map((r, idx) => (
                    <li key={idx}>{r.reason}
                        <ul style={{ marginLeft: '3%' }}>{r.specifications && r.specifications.length && r.specifications.split(',').map(spec => {
                            const key = [...projectRequirementsArray(), { text: 'Residential Construction', value: 'homeBuilding' }].find(k => k.value.toString() === spec)
                            return !!key && <li>{key.text}</li>
                        })}</ul></li>
                ))}
            </ul>
            <p>
                Please submit your submission and your designated underwriter will contact you shortly to assist you further
            </p>
            </div> 
        </header>
    )

}
export default KnockoutDraftHeader